import React from 'react';
import { appMethod as app } from '@utils/app';
import { Radio } from 'antd-mobile';

import './Pay.less';


export class Pay extends React.Component{
  timer = null;

  constructor(props){
    super(props);
    this.state = {
      payShow: false,
      choosePayShow: false,
      choosePayType: 'wxpay',
      wxcodePay: false,
      wxcodeUrl: '',
      payLoading: false,
      orderPrice: 0
    }
    this.orderId = '';
    this.orderType = 1;
    this.franchisee = '';
    this.success = '';
    this.fail = '';
    this.cancel = '';
  }

  // 外部调用接口
  showPay = (options) => {
    if(!options.orderId){
      console.error('orderId 是必传字段');
      return;
    }

    this.orderId = options.orderId;
    this.orderType = options.orderType || 1; //说明： http://confluence.zhichiwangluo.com/pages/viewpage.action?pageId=2884350
    this.franchisee = options.franchisee || '';
    // this.success = options.success || '';
    // this.fail = options.fail || '';
    this.cancel = options.cancel || '';
    this.successUrl = options.successUrl || '';
    this.failUrl = options.failUrl || '';

    this.getOrder();
    if(app.isWeixin()){ // 微信里面直接调微信支付
      this.chooseWXPay();
    }else if(app.isPC()){ //pc上暂时用微信二维码支付
      this.chooseWXCodePay();
    }else{ // 其他的暂时选择支付方式弹窗
      this.setState({
        payShow: true,
        choosePayShow: true
      })
    }
    this.setState({
      payLoading: false,
      orderPrice: 0
    });
  }

  // pc上面弹出微信支付支付二维码时查询订单是否支付
  getOrder(){
    let that = this;
    app.sendRequest({
      url: '/index.php?r=AppShop/getOrder',
      data: {
        order_id: this.orderId,
        sub_shop_app_id: this.franchisee
      },
      hideLoading: false,
      success: (res) => {
        that.setState({
          orderPrice: res.data[0].form_data.total_price
        })
      },
      fail: () => {
      }
    });
  }

  // pc上面弹出微信支付支付二维码时查询订单是否支付
  orderIsPay(){
    let that = this;
    app.sendRequest({
      url: '/index.php?r=AppShop/getOrder',
      data: {
        order_id: this.orderId,
        sub_shop_app_id: this.franchisee
      },
      success: (res) => {
        if(res.data[0].form_data.status != 0){
          that.closePay();
          that.successUrl && app.turnToPage(that.successUrl, {}, true);
          // typeof that.success === 'function' && that.success(res);
        }
      },
      fail: () => {
        // clearInterval(this.timer);
        // typeof that.fail === 'function' && that.fail();
      }
    });
  }

  // pc上面弹出微信支付支付二维码时轮询是否支付了
  checkOrderPay(){
    clearInterval(this.timer);
    this.timer = setInterval(() => {
      this.orderIsPay();
    }, 2000);
  }

  // 关闭支付弹窗
  closePay(){
    clearInterval(this.timer);
    app.removeStorage({key: 'payCallbackUrl'});
    this.setState({
      payShow: false,
      choosePayShow: false,
      wxcodePay: false
    });
  }
  
  // 点击关闭支付弹窗事件
  closePayEvent = () => {
    this.closePay();
    typeof this.cancel === 'function' && this.cancel();
  }

  // 选择支付方式
  changePayType = (type) => {
    this.setState({
      choosePayType: type
    })
  }

  getIntactUrl(url){
    let urlArr = url.split('/');
    url = window.location.origin + '/zc_webapp/' + urlArr[urlArr.length - 1];
    if(!/app_id/.test(url)){
      if(url.indexOf('?') < 0){
        url = url +'?app_id=' + app.getAppId();
      }else{
        url = url +'&app_id=' + app.getAppId();
      }
    }
    return url;
  }

  getTurnToPageUrl(url){
    if(url && !/app_id/.test(url)){
      if(url.indexOf('?') < 0){
        url = url +'?app_id=' + app.getAppId();
      }else{
        url = url +'&app_id=' + app.getAppId();
      }
    }
    return url;
  }

  // 去支付
  goPay = () => {
    let payType = this.state.choosePayType;
    if(this.state.payLoading){
      return;
    }
    this.setState({
      payLoading: true
    });
    let successUrl = this.getTurnToPageUrl(this.successUrl);
    let failUrl = this.getTurnToPageUrl(this.failUrl);
    app.setStorage({
      key: 'payCallbackUrl',
      data: {
        successUrl: successUrl,
        failUrl: failUrl
      }
    });
    if(payType == 'wxpay'){
      this.wxPay();
    }else if(payType == 'alipay'){
      this.aliPay();
    }
  }

  // 微信支付
  wxPay = () => {
    if(app.isWeixin()){ //微信内部直接调起支付
      this.chooseWXPay();
    } if(app.isPC()){ // pc上面弹出支付二维码
      this.chooseWXCodePay();
    }else{ // 在手机上使用h5调起微信支付
      this.chooseWXH5Pay();
    }
  }

  // 微信内部支付
  chooseWXPay = () => {
    let that = this;
    that.getUniPay({
      payment_id: 18,
      success: function(res){
        let param = res.data;
        wx.chooseWXPay({
          timestamp: param.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
          nonceStr: param.nonceStr, // 支付签名随机串，不长于 32 位
          package: param.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
          signType: param.signType || 'MD5', // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
          paySign: param.paySign, // 支付签名
          success: function (res) {
            // that.wxPaySuccess(param);
            that.successUrl && app.turnToPage(that.successUrl, {}, true);
            // typeof that.success === 'function' && that.success(res);
          },
          cancel: function(res){
            app.showModal({
              content: '支付已取消',
              confirm: function () {
                // typeof that.fail === 'function' && that.fail();
                that.failUrl && app.turnToPage(that.failUrl, {}, true);
              }
            });
          },
          fail: function(res){
            if (res.errMsg === 'requestPayment:fail') {
              res.errMsg = '支付失败';
            }
            if (res.errMsg.indexOf('ETIMEDOUT')){
              res.errMsg = '支付超时！';
            }
            app.showModal({
              content: res.errMsg
            })
            // that.wxPayFail(param, res.errMsg);
            that.failUrl && app.turnToPage(that.failUrl, {}, true);
            // typeof that.fail === 'function' && that.fail();
          }
        });
      },
      fail: function(){
      },
      complete: function(){
        that.setState({
          payLoading: false
        });
      }
    });
    
  }

  // pc端微信二维码支付
  chooseWXCodePay = () => {
    let that = this;
    that.getUniPay({
      payment_id: 0,
      success: function(res){
        that.checkOrderPay();
        that.setState({
          wxcodePay: true,
          payShow: true,
          choosePayShow: false,
          wxcodeUrl: res.data
        })
      },
      fail: function(){
      },
      complete: function(){
        that.setState({
          payLoading: false
        });
      }
    });
  }

  // 手机上使用h5调起微信支付
  chooseWXH5Pay = () => {
    let that = this;
    app.turnToPage('/paying?orderId=' + that.orderId, {}, true);
    that.getUniPay({
      payment_id: 19,
      success: function(res){
        if(res.data.return_msg == 'OK'){
          let mweburl = res.data.mweb_url;
          let redirect_url = that.getIntactUrl('/paying?isPayBack=1&orderId=' + that.orderId);
          mweburl = mweburl + '&redirect_url=' + encodeURIComponent(redirect_url);
          window.location.href = mweburl;
          that.setState({
            payShow: false,
            choosePayShow: false
          })
        }
      },
      fail: function(){
      },
      complete: function(){
        that.setState({
          payLoading: false
        });
      }
    });
  }

  /*
  *@param {number} param.payment_id 支付方式id。默认0
  *@param {function} param.success 请求成功回调
  *@param {function} param.fail 请求失败回调
  */
  getUniPay(param){
    let that = this;
    app.sendRequest({
      url: '/index.php?r=pay/Pay/GetUniPay',
      data: {
        order_id: this.orderId,
        order_type: this.orderType,
        payment_id: param.payment_id || 0,  //相关说明 http://confluence.zhichiwangluo.com/pages/viewpage.action?pageId=2884343
        return_url: param.return_url || '',  //这个针对支付宝
        sub_shop_app_id: this.franchisee
      },
      hideLoading: false,
      success: function(res){
        typeof param.success === 'function' && param.success(res);
      },
      fail: function(res){
        typeof param.fail === 'function' && param.fail(res);
      },
      complete: function(res){
        typeof param.complete === 'function' && param.complete(res);
      },
      successStatusAbnormal: function(res) {
        param.fail && (typeof param.fail === 'function') && param.fail(res);
        that.failUrl && app.turnToPage(that.failUrl, {}, true);
      }
    })
  }

  // 支付宝支付
  aliPay = () => {
    if(app.isPC()){ // pc上去新页面进入支付宝支付
      this.chooseALiPCPay();
    }else{ // 在手机上使用h5调起支付宝支付
      this.chooseALiH5Pay();
    }
  }
  
  // pc端支付宝支付
  chooseALiPCPay = () => {
    let that = this;
    let redirect_url = that.getIntactUrl('/paying?isPayBack=1&orderId=' + that.orderId);
    app.turnToPage('/paying?orderId=' + that.orderId, {}, true);
    that.getUniPay({
      payment_id: 21,
      return_url: redirect_url,
      success: function(res){
        let divDom = document.createElement('div')
        divDom.innerHTML = res.data;
        divDom.removeChild(divDom.childNodes[1]);
        document.body.appendChild(divDom);
        document.forms['alipaysubmit'].submit();
        setTimeout(() => {
          divDom.remove();
        }, 50)
        that.setState({
          payShow: false,
          choosePayShow: false
        })
      },
      fail: function(){
      },
      complete: function(){
        that.setState({
          payLoading: false
        });
      }
    });
  }

  // 手机上支付宝支付
  chooseALiH5Pay = () => {
    let that = this;
    let redirect_url = that.getIntactUrl('/paying?isPayBack=1&orderId=' + that.orderId);
    app.turnToPage('/paying?orderId=' + that.orderId, {}, true);
    that.getUniPay({
      payment_id: 20,
      return_url: redirect_url,
      success: function(res){
        let divDom = document.createElement('div')
        divDom.innerHTML = res.data;
        divDom.removeChild(divDom.childNodes[1]);
        document.body.appendChild(divDom);
        document.forms['alipaysubmit'].submit();
        setTimeout(() => {
          divDom.remove();
        }, 50)
        that.setState({
          payShow: false,
          choosePayShow: false
        })
      },
      fail: function(){
      },
      complete: function(){
        that.setState({
          payLoading: false
        });
      }
    });
  }

  // 支付成功
  wxPaySuccess = (param) => {
    let orderId = param.orderId,
      goodsType = param.goodsType,
      formId = param.package.substr(10),
      t_num = goodsType == 1 ? 'AT0104' : 'AT0009';

    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppShop/SendXcxOrderCompleteMsg',
      data: {
        formId: formId,
        t_num: t_num,
        order_id: orderId
      }
    })
  }

  /**
   * 支付成功
   */
  wxPayFail = (param, errMsg) => {
    let orderId = param.orderId,
    formId = param.package.substr(10);

    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppShop/SendXcxOrderCompleteMsg',
      data: {
        formId: formId,
        t_num: 'AT0010',
        order_id: orderId,
        fail_reason: errMsg
      }
    })
  }

  render(){
    let {
      payShow,
      choosePayShow,
      choosePayType,
      wxcodePay,
      wxcodeUrl,
      payLoading,
      orderPrice
    } = this.state;
    if(!payShow){
      return null;
    }
    return (
      <div className="common-api pay-wrap">
        <div className="choose-pay" style={{bottom: choosePayShow ? 0 : '-7rem'}}>
          <div className="choose-pay-head">支付</div>
          <div className="pay-close icon-moon icon-closes" onClick={this.closePayEvent}></div>
          <div className="pay-money"><label>¥</label><span>{orderPrice}</span></div>
          <div className="choose-item-warp">
            <div className="choose-pay-item pay-item-wx" onClick={() => this.changePayType('wxpay')}><label className="pay-item-logo icon-moon icon-weixin-pay"></label><span>微信支付</span><Radio className="pay-item-radio" checked={choosePayType === 'wxpay'}></Radio></div>
            <div className="choose-pay-item pay-item-ali" onClick={() => this.changePayType('alipay')}><label className="pay-item-logo icon-moon icon-alipay"></label><span>支付宝</span><Radio className="pay-item-radio" checked={choosePayType === 'alipay'}></Radio></div>
          </div>
          <div className={`choose-pay-btn ${payLoading ? 'choose-btn-disabled' : ''}`} onClick={this.goPay}>确认支付</div>
        </div>
        {/* pc出二维码支付 */}
        <div className="pay-qrcode-wrap" hidden={!wxcodePay}>
          <div className="pay-close icon-moon icon-closes" onClick={this.closePayEvent}></div>
          <div className="pay-qrcode">
              <img src={wxcodeUrl} />
          </div>
          <div className="pay-qrcode-tip">长按二维码扫描支付</div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/pay/Pay.jsx